import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { MessageCircle } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const WhatsAppButton = () => {
  const [settings, setSettings] = useState({});
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    fetchSettings();
    // Show button after a short delay
    setTimeout(() => setIsVisible(true), 1000);
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/cms/settings`);
      setSettings(response.data);
    } catch (error) {
      console.error('Error fetching settings:', error);
    }
  };

  const handleWhatsAppClick = () => {
    // Use whatsapp_number if available, otherwise fall back to contact_phone
    const phone = settings.whatsapp_number || settings.contact_phone || '+971501539333';
    const cleanPhone = phone.replace(/[^0-9+]/g, '');
    
    // Default message
    const message = encodeURIComponent('Hello! I would like to get in touch with you.');
    
    // Open WhatsApp with pre-filled message
    window.open(`https://wa.me/${cleanPhone}?text=${message}`, '_blank');
  };

  return (
    <button
      onClick={handleWhatsAppClick}
      className={`fixed bottom-6 right-6 z-50 bg-[#25D366] hover:bg-[#20BD5A] text-white rounded-full p-4 shadow-2xl transition-all duration-300 hover:scale-110 group ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
      }`}
      aria-label="Chat on WhatsApp"
      title="Chat on WhatsApp"
    >
      <MessageCircle className="w-7 h-7 group-hover:animate-pulse" />
      
      {/* Tooltip */}
      <div className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-gray-800 text-white px-3 py-2 rounded-lg text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
        Chat with us on WhatsApp
        <div className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-full border-8 border-transparent border-l-gray-800"></div>
      </div>

      {/* Pulse Animation Ring */}
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20"></span>
    </button>
  );
};

export default WhatsAppButton;
